import EntityService, { WithSubcollection } from '@/services/EntityService'
import { Customer, customerConvertor } from '@/models/customer'
import { Project, projectConverter } from '@/models/project'
import InvoiceService from '@/services/InvoiceService'
import ProposalService from '@/services/ProposalService'
import BudgetService from '@/services/BudgetService'
import ProjectService from './ProjectService'

@WithSubcollection<Project>('projects', projectConverter)
export default class CustomerService extends EntityService<Customer> {
  constructor() {
    super({ collectionName: 'customers', converter: customerConvertor })
  }

  async getCompanies() {
    return await this.find_by('isCompany', '==', true)
  }

  async getCustomers() {
    return await this.find_by('isCompany', '==', false)
  }

  async getComapny(companyId: string) {
    return await this.find(companyId)
  }

  async getInvoices(customerId: string) {
    const invoiceSevice = new InvoiceService()
    return await invoiceSevice.find_by('customerId', '==', customerId)
  }

  async getInvoice(customerId: string, invoiceId: string) {
    const invoiceSevice = new InvoiceService()
    return await invoiceSevice.find(invoiceId)
  }

  async getProposals(customerId: string) {
    const proposalService = new ProposalService()
    const budetService = new BudgetService()
    const proposals = await proposalService.find_by('customerId', '==', customerId)

    const uniquProposalIds = Array.from(new Set(proposals?.map(proposal => proposal.projectId)))
    const budgets = await budetService.find_by('projectId', 'in', uniquProposalIds)

    return proposals.map(proposal => {
      const budget = budgets.find(budget => budget.projectId === proposal.projectId)
      return { ...proposal, budget }
    })
  }

  async getProposal(customerId: string, proposalId: string) {
    const proposalService = new ProposalService()
    return await proposalService.find(proposalId)
  }

  async updateCustomerProject(oldCustomerId: string, projectId: string, project: Project) {
    // update project with new data
    const updateProject  = await this.updateProject(project.customerId, projectId, project)


    // move project messages to new customer
    if (oldCustomerId !== project.customerId) {
      // logic to move messages
      await new ProjectService().moveMessagesToNewCustomer(projectId, oldCustomerId, project.customerId)
      // delete project from old customer
      await this.deleteProject(oldCustomerId, projectId)
    }

    return updateProject
  }
}
